// extracted by mini-css-extract-plugin
module.exports = {"browser":"browser_browser__ndqqV"};